import '@stripe/stripe-js'

import Vue from 'vue'
import VueMeta from 'vue-meta'
import VueFormulate from '@braid/vue-formulate'
import { de, en } from '@braid/vue-formulate-i18n'
import browserDetect from 'vue-browser-detect-plugin'

import App from '@/App.vue'
import '@/registerServiceWorker'
import router from '@/router'
import i18n from '@/i18n'
import bus from '@/bus'
import { store } from '@/store'
import '@/matomo'

import plausible from '@/plausible'

import '@/assets/tailwind.scss'

Vue.config.productionTip = false

Vue.use(browserDetect)
Vue.use(VueMeta)
Vue.use(VueFormulate, {
  plugins: [de, en],
  classes: {
    label: 'block text-sm font-medium leading-5 text-gray-500',
    element: 'mt-1 block w-full rounded-lg shadow-sm',
    input(context) {
      switch (context.classification) {
        default:
          return 'appearance-none block w-full px-3 py-2 border border-gray-300 rounded-lg placeholder-gray-400 focus:outline-none focus:ring-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5'
      }
    },
    help: 'text-xs mb-1 text-gray-400',
    errors: 'mt-1',
    error: 'text-sm font-medium mb-1 text-primary-500 '
  }
})

Vue.use(plausible)

const main = async () => {
  // found an artist
  bus.on(['reward/read'], () => {
    const fbId = store.getters['reward/fbId']
    if (window.fbq) {
      window.fbq('init', fbId)
      window.fbq('track', 'PageView')
    }
  })

  // if (process.env.NODE_ENV === 'development') {
  //   const { makeServer } = await import('@/apiMock')
  //   makeServer()
  // }

  new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App)
  }).$mount('#app')
}

main()
